'use client'

import { AiraloPackage } from 'lib/airlo-api/getPackages'
import styles from './PlanCard.module.css'
import NextImage from 'next/image'

import {
  Button,
  Center,
  Group,
  Paper,
  Stack,
  Text,
  Image,
  PaperProps,
  Box
} from '@mantine/core'
import { Earth, Wifi,CalendarFold, Tag, PhoneCall, MessageSquareTextIcon, Signal  } from 'lucide-react'

type PlanCardProps = {
  airaloPackage: AiraloPackage
  lang: string
  locale: any
} & PaperProps

type CardLabelProps = {
  label: string
  icon: React.ReactNode
  children?: React.ReactNode
}

export function PlanCard({
  airaloPackage,
  lang,
  locale,
  ...props
}: PlanCardProps) {
  const altColor = airaloPackage.isUnlimited || airaloPackage.hasVoice || airaloPackage.hasText 

  const CardRow: React.FC<CardLabelProps> = ({ label, icon, children }) => {
  return (
    <Group
    align='center'
    justify='center'
    wrap='nowrap'
      styles={{
        root: {
          borderBottom: altColor ? '1px solid #55B08D' : '1px solid #e0e0e0'
        }
      }}
      w="100%"
      pb='xs'
    >
      <Group gap={'xs'}    wrap='nowrap'>
        {icon} <Text size='xs'>{label}</Text>
      </Group>
      <Box ml='auto'>

      {children}
      </Box>
    </Group>
  )
}

  return (
    <Paper
      key={airaloPackage.gb + airaloPackage.days + airaloPackage.price}
      radius="xl"
      bg={altColor ? 'redi-green.10' : 'white'}
      {...props}
    >
      <Center mih={220} p="sm" mx="md">
        <Stack mt='md' h="100%" w="100%" justify="center" align="center" gap={'xs'}>
          <CardRow label={locale?.components?.planCard?.coverage} icon={<Earth />}>
            <Image
              src={airaloPackage.image}
              alt={'flag of: ' + airaloPackage.value}
              width={32}
              height={24}
              w={32}
              h={24}
              // m={10}
              component={NextImage}
              quality={60}
              style={{
                boxShadow: '0px 0px 1px 0px gray'
              }}
            />
          </CardRow>
          {airaloPackage.operator && (
            <CardRow label={locale?.components?.planCard?.operator || 'Operator'} icon={<Signal />}>
              <Text size='sm' c='redi-blue.0' fw="bold">{airaloPackage.operator}</Text>
            </CardRow>
          )}
            <CardRow label={locale?.components?.planCard?.internet_text} icon={<Wifi />}>

            {
              airaloPackage.gb === 'Unlimited' ?
              <Text size='sm'c='redi-blue.0' fw="bolder">{locale?.components?.planCard?.unlimited}</Text>
              :  <Text size='sm'c='redi-blue.0' fw="bolder">{airaloPackage.gb}</Text>
            }
             
            </CardRow>
            { airaloPackage.hasText || airaloPackage.hasText ? <>
            
             <CardRow label={locale?.components?.planCard?.calls} icon={<PhoneCall />}>
              <Text size='sm'c='redi-blue.0' fw="bold">{`${airaloPackage.voiceMinutes} ${locale?.components?.planCard?.has_voice}`}</Text>
            </CardRow>
            <CardRow label={locale?.components?.planCard?.sms_text} icon={<MessageSquareTextIcon />}>
              <Text size='sm'c='redi-blue.0' fw="bolder">{`${airaloPackage.textMessages} ${locale?.components?.planCard?.has_text}`}</Text>
            </CardRow>
            </> : null}


            <CardRow label={locale?.components?.planCard?.validity} icon={<CalendarFold />}>
              <Text  size='sm' c='redi-blue.0' fw="bold">{airaloPackage.days} {locale?.components?.planCard?.days}</Text>
            </CardRow>
                <CardRow label={locale?.components?.planCard?.price} icon={<Tag />}>
                <Text size='md' c='redi-blue.0'  span fw="bolder" style={{ whiteSpace: 'nowrap' }}>
                  {`$${airaloPackage.price} USD`}
                </Text>
            </CardRow>
            <Center w={'100%'} 
            m="xs" mx={0}>
               <Button
            // className={styles.Button}
            color="redi-blue.0"
            w={'100%'}
            variant='outline'
          
            component="a"
            href={`/${lang}/stripe/${airaloPackage.value}/${airaloPackage.id}`}
          >
            {locale?.components?.planCard?.buy}
          </Button>

            </Center>
         
        </Stack>
      </Center>
    </Paper>
  )
}
